import { render, staticRenderFns } from "./CostRefetch.vue?vue&type=template&id=66d484b2&scoped=true"
import script from "./CostRefetch.vue?vue&type=script&lang=js"
export * from "./CostRefetch.vue?vue&type=script&lang=js"
import style0 from "./CostRefetch.vue?vue&type=style&index=0&id=66d484b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d484b2",
  null
  
)

export default component.exports